import React, {createRef} from 'react';
import {Grid} from '@mantine/core';
import {useFormikContext} from 'formik'
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import MantineSelectField from "../../../../FormikUtils/MantineSelectField";
import MantineDateField from "../../../../FormikUtils/MantineDateField";
import PhoneInput from "react-phone-number-input";
import MantineInputRefField from "../../../../FormikUtils/MantineInputRefField";
import useStyles from '../styles'
import MantineDependantField from "../../../../FormikUtils/MantineDependantField";


export default function ClienteForm(props) {
    const {values, setFieldValue} = useFormikContext();
    const {
        formField: {
            nombre,
            apellido,
            fechaNacimiento,
            dni,
            cuit,
            sexo,
            domicilio,
            telefono,
            email,
        },
    } = props;
    const classes = useStyles();
    const ref = createRef();

    const opcionesSexo = [
        {value: '1', label: 'Femenino'},
        {value: '2', label: 'Masculino'}
    ];

    function CuitGenerator() {
        if (values.dni) {
            if ((values.dni).length === 8 && values.sexo !== '') {
                let genderNumber = values.sexo === '2' ? 20 : 27;

                const generateverificator = () => {
                    const multipliers = [2, 3, 4, 5, 6, 7];
                    const genderNumberAndDNI = `${genderNumber}${values.dni}`;

                    let total = 0;
                    let multpIndex = 0;
                    for (let i = String(genderNumberAndDNI).length - 1; i > -1; i--) {
                        const sum = genderNumberAndDNI[i] * multipliers[multpIndex];
                        total += sum;
                        if (multpIndex === 5) multpIndex = 0;
                        else multpIndex += 1;
                    }

                    const verificator = 11 - (total % 11);
                    if (verificator === 10) {
                        genderNumber = 23;
                        return generateverificator();
                    }
                    if (verificator === 11) return 0;
                    return verificator;
                };
                const verificator = generateverificator();

                return `${genderNumber}${values.dni}${verificator}`
            }
        }
    }

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={nombre.name}
                        label={nombre.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={apellido.name}
                        label={apellido.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={sexo.name}
                        label={sexo.label}
                        data={opcionesSexo}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={dni.name}
                        label={dni.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineDependantField
                        dependantField={cuit}
                        dependsOn={dni}
                        dependsOnTwo={sexo}
                        calculateValueFunction={CuitGenerator}
                        formatDisplay={(v) => v}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineDateField
                        name={fechaNacimiento.name}
                        label={fechaNacimiento.label}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <div className={classes.field}>
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={MantineInputRefField}
                            name={telefono.name}
                            label={telefono.label}
                            value={values.telefono}
                            onChange={(e) => {
                                /** @namespace e.length **/
                                if (e && e.length > 12) {
                                    setFieldValue(telefono.name, e)
                                }
                            }}
                            withAsterisk
                        />
                    </div>
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={email.name}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={domicilio.name}
                        label={domicilio.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}/>
            </Grid>
        </React.Fragment>
    );
}
